import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=bbbb2808"
import script from "./Duration.vue?vue&type=script&lang=js"
export * from "./Duration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports